import React, { useEffect, useState } from 'react'

import {Loader} from '@ohif/ui';
import { getImagesForThumbnail } from '@custom/Apis/apis';

const SendSeriesDetailCard = ({date, time, modality, seriesNo, images, bodyPart, seriesDisc, patPos, selectedItems, seriesInstanceUID, setSelectedItems, studyInstanceUID}) => {

  const [seriesThumbImgSrc, setSeriesThumbImgSrc] = useState(null);
  const [imgSrcLoading, setImgSrcLoading] = useState(false);

  const handleCardSelection = () =>{
    if(!selectedItems.includes(seriesInstanceUID)){
      setSelectedItems([...selectedItems, seriesInstanceUID]);
    }
    else{
      setSelectedItems(()=>{
        return selectedItems.filter(item => item != seriesInstanceUID);
      })
    }
  }

  const fetchSeriesImage = async () => {

    setImgSrcLoading(true);

    const payload = {
      studyInstanceUID,
      seriesInstanceUID,
    }

    try{
      const resp = await getImagesForThumbnail(payload);

      if(resp?.ok){
        const imageBlob = await resp.blob();
        const imageObjectURL = URL.createObjectURL(imageBlob);
        setSeriesThumbImgSrc(imageObjectURL);
      }
      else{
        console.log(`Error occured in fetching image: ${resp?.status}`)
      }
    }
    catch(error){
      console.log(`Error occured in fetching image: ${error}`)
    }
    finally{
      setImgSrcLoading(false);
    }
  }

  useEffect(()=>{
    fetchSeriesImage();
  }, []);

  return (
    <div className="w-52 border border-teal-500 rounded-lg p-4 bg-white shadow-lg" style={{
      border: '1px solid #38b2ac',
      borderRadius: '0.5rem'
      }}>
      <div className="flex justify-center mb-4">
        {
          imgSrcLoading ? <Loader isLoaderOpen={imgSrcLoading} /> :
          <img
            src={seriesThumbImgSrc}
            alt="Scan Image"
            className="w-full h-[7rem] object-cover rounded"
          />
        }
      </div>
      <div className="text-sm space-y-2">
        <div className="flex justify-between">
          <span>Date:</span> <span>{date}</span>
        </div>
        <div className="flex justify-between">
          <span>Time:</span> <span>{time}</span>
        </div>
        <div className="flex justify-between">
          <span>Modality:</span> <span>{modality}</span>
        </div>
        <div className="flex justify-between">
          <span>Series No.:</span> <span>{seriesNo}</span>
        </div>
        <div className="flex justify-between">
          <span>Images:</span> <span>{images}</span>
        </div>
        <div className="flex justify-between">
          <span>Body Part:</span> <span>{bodyPart}</span>
        </div>
        <div className="flex justify-between">
          <span>Series Disc:</span> <span>{seriesDisc}</span>
        </div>
        <div className="flex justify-between">
          <span>Pat. Pos.:</span> <span>{patPos}</span>
        </div>
      </div>
      <button className={selectedItems.includes(seriesInstanceUID) ? "mt-4 w-full bg-[#0EA7A2] text-white py-2 rounded" : "mt-4 w-full bg-white text-black py-2 rounded hover:bg-gray-100" }
        onClick={handleCardSelection} style={{border: '1px solid #150823', borderRadius: '0.5rem'}}>
        {
          selectedItems.includes(seriesInstanceUID) ? 'Selected' : 'Select'
        }
      </button>
    </div>
  )
}

export default SendSeriesDetailCard;
